import { cn } from "@/utils/ui";
import { Link } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { AppHeader } from "./app-header";
import { GotoTopButton } from "./goto-top-button";

export function AppLayout({
  children,
  fixedHeader,
}: PropsWithChildren<{ fixedHeader?: boolean }>) {
  return (
    <>
      <AppHeader className={cn(fixedHeader && "fixed top-0 inset-x-0 z-10")} />
      {fixedHeader && <div className="h-18" />}

      <main className="my-4 min-h-[calc(100dvh-4.5rem-2rem-2rem)]">
        {children}
      </main>

      <GotoTopButton />

      <footer className="flex items-center justify-between h-8 px-6 py-2 bg-gray-subtle-bg">
        <div className="flex gap-6 text-xs text-gray-fg-secondary">
          <div className="flex gap-4">
            <Link to="/">关于我们</Link>
            <Link to="/">帮助中心</Link>
          </div>

          <div className="flex gap-4">
            <span>友情链接：</span>
            <Link to="/">Link 1</Link>
            <Link to="/">Link 2</Link>
            <Link to="/">Link 3</Link>
          </div>
        </div>

        <div className="flex gap-4 text-xs text-gray-fg-secondary">
          <span>粤公网安备 4401060200XXXX号</span>
          <span>粤ICP备2000XXXX号</span>
          <span>Copyright &copy; 2025 月球信息科技（广东）有限公司</span>
        </div>
      </footer>
    </>
  );
}
